<template>
  <!-- popup (s) -->
  <div id="changePwdPop" class="popWrap nowOpen">
    <div class="popup">
      <div class="popContain">
        <div class="popCont full hasBtn" tabindex="-1" role="dialog">
          <div class="popHead">
            <h1 class="titH1">비밀번호 변경안내</h1>
          </div>
          <div class="popBody">
            <div class="popInner">
              <!-- 본문 (s) -->
              <section>
                <div class="guideMsg">
                  <p class="txtL">
                    정기적인 비밀번호 변경으로
                    <br />
                    소중한 개인정보를 지켜주세요.
                  </p>
                  <p class="txt">
                    회원님께서는 90일이상 비밀번호를 변경하지 않으셨습니다. 동일한 비밀번호를 장기간 사용할 경우 개인정보 도용 및 유출 등의 위험이
                    있습니다.
                  </p>
                  <p class="txt pointC1 bold">
                    안전한 서비스 이용을 위해 비밀번호를 변경해주세요.
                  </p>
                </div>

                <ValidationObserver ref="changePwdform">
                  <div class="formArea">
                    <span class="label">기존비밀번호</span>
                    <ValidationProvider name="비밀번호" rules="required" v-slot="{ errors }" vid="password">
                      <input
                        type="password"
                        id="ipt1_pw"
                        class="ipt"
                        placeholder="현재 비밀번호를 입력해주세요."
                        title="기존비밀번호 입력(현재 비밀번호를 입력해주세요.)"
                        value=""
                        v-model="password"
                      />
                      <p class="fieldMsg error" id="idMsg" v-if="errors[0]">
                        {{ errors[0] }}
                      </p>
                    </ValidationProvider>
                    <!-- 비밀번호가 올바르지않습니다. -->
                    <span class="label">새 비밀번호</span>
                    <ValidationProvider name="비밀번호" rules="required|password" v-slot="{ errors }" vid="newPassword">
                      <input
                        type="password"
                        id="ipt2_pw"
                        class="ipt"
                        placeholder="영문 대/소문자, 숫자, 특수문자 포함 8자리 이상"
                        title="새 비밀번호 입력(영문 대/소문자, 숫자, 특수문자 포함 8자리 이상)"
                        value=""
                        v-model="newPassword"
                      />
                      <p class="fieldMsg error" id="idMsg" v-if="errors[0]">
                        {{ errors[0] }}
                      </p>
                    </ValidationProvider>
                    <!-- <p class="fieldMsg error" id="idMsg">
                    영문 대/소문자, 숫자, 특수문자 포함 8자리 이상이어야 합니다.
                  </p>
                  <p class="fieldMsg error" id="idMsg">
                    조건에 맞지 않는 비밀번호입니다.
                  </p>
                  <p class="fieldMsg error" id="idMsg">
                    이전3회와 동일한 비밀번호는 설정이 불가합니다.
                  </p> -->

                    <span class="label">새 비밀번호 확인</span>
                    <ValidationProvider name="새 비밀번호" rules="required|confirmed:newPassword" v-slot="{ errors }" vid="newPasswordChk">
                      <input
                        type="password"
                        id="ipt3"
                        class="ipt"
                        placeholder="동일한 비밀번호를 입력해주세요"
                        title="새 비밀번호 확인 입력(동일한 비밀번호를 입력해주세요)"
                        value=""
                        v-model="newPasswordChk"
                      />
                      <!-- <p class="fieldMsg error" id="idMsg">
                    비밀번호가 일치하지 않습니다.
                  </p>
                  <p class="fieldMsg error" id="idMsg">
                    설정한 비밀번호와 동일하지 않습니다.
                  </p> -->
                      <p class="fieldMsg error" id="idMsg" v-if="errors[0]">
                        {{ errors[0] }}
                      </p>
                    </ValidationProvider>
                  </div>
                </ValidationObserver>
              </section>
              <!-- 본문 (e) -->
            </div>
          </div>

          <div class="btnArea sticky two half">
            <button type="button" class="btn_s" @click="$emit('changeLater')">
              90일 뒤에 변경하기
            </button>
            <button type="button" class="btn_p" @click="changePwd">
              수정완료
            </button>
          </div>

          <button type="button" class="btnIco_close" @click="$emit('close')">
            <span>팝업 닫기</span>
          </button>
        </div>
      </div>
    </div>
    <MessagePop v-if="messagePop" @close="close">
      <p v-html="msg"></p>
    </MessagePop>
  </div>
  <!-- popup (e) -->
</template>

<script>
import ApiService from '@/common/api.service';
import JwtService from '@/common/jwt.service';
import { isEmpty } from '@/common/common.function';
import { INPUT_INFO_CHECK, CHANGE_PASSWORD } from '@/store/message.type';
import MessagePop from '@/components/popup/MessagePop';

export default {
  name: 'ChangePwdPop',
  components: {
    MessagePop,
  },
  props: ['userId', 'token'],
  data() {
    return {
      password: null,
      newPassword: null,
      newPasswordChk: null,
      messagePop: false,
      success: false,
    };
  },
  methods: {
    async changePwd() {
      this.$refs.changePwdform.validate().then(success => {
        if (!success) {
          this.msg = INPUT_INFO_CHECK;
          this.errorCode = 'INPUT_INFO_CHECK';
          this.messagePop = true;
        } else {
          // API 호출
          ApiService.service('PUT', 'user/password', {
            request: {
              newPassword: this.newPassword,
              password: this.password,
              userId: this.userId,
            },
            serviceType: 'app',
          })
            .then(({ data }) => {
              console.log(data);
              if (!isEmpty(data.error)) {
                this.msg = data.error;
                this.errorCode = data.errorCode;
                // this.password = null;
                // this.newPassword = null;
                // this.newPasswordChk = null;
              } else {
                this.errorCode = null;
                this.msg = CHANGE_PASSWORD;
                this.success = true;
              }
              this.messagePop = true;
            })
            .catch(response => {
              console.log(response);
            });
        }
      });
    },
    close() {
      this.messagePop = false;
      if (this.success) {
        JwtService.logout();
        this.$emit('close');
      }
    },
  },
};
</script>
